import { cloneDeep } from 'lodash'

export const formatSearch = (search) => {
  return {
    ...search,
    page: search?.page || search?.current_page,
    size: search?.size || search?.page_size,
    task_name: search?.task_name || undefined,
  }
}

export const getCaseId = (ids, groupLists, rootId) => {
  if (!ids || ids.length === 0) return []
  if (ids.length === 1 && ids[0] === rootId) return [[rootId]]
  const copy = cloneDeep(groupLists)
  copy[0]?.children.forEach((item) => (item.parentId = rootId))

  const res = []
  let parent_id: any
  const startTime = new Date().getTime()

  const findParentId = (targetId, arr) => {
    if (!arr || arr.length === 0) {
      return
    }

    for (const item of arr) {
      if (item?.value === targetId) {
        parent_id = item.parentId
      } else {
        findParentId(targetId, item.children)
      }
    }
  }

  for (const id of ids) {
    parent_id = id
    const temp = [id]

    while (parent_id != rootId) {
      const endTime = new Date().getTime()
      if (endTime - startTime >= 500) {
        return []
      }
      findParentId(parent_id, copy)
      temp.push(parent_id)
    }
    res.push(temp.reverse())
  }
  return res
}

export const getCaseId111 = (departmentList: any, checkedId: string) => {
  const fm = (obj: any, arr: any[]) => {
    const temp: any = []
    const fn = (obj: any, newArr: any) => {
      const tempArr = newArr.slice(0)
      tempArr.push(obj)
      if (checkedId === obj?.id) {
        arr.push(tempArr)
      } else if (obj?.children && obj?.children.length) {
        obj?.children.forEach((m: any) => {
          fn(m, tempArr)
        })
      }
    }
    fn(obj, temp)
    return arr
  }
  const allArr = fm(departmentList?.[0], [])
  if (allArr && allArr.length) {
    return allArr[0].map((item) => item?.id)
  } else {
    return []
  }
}

export const formatCreateOrUpdateSearch = (search) => {
  const { dialog_case_group_id: dialog_case_group_ids, ...rest } = search
  return {
    task: {
      dialog_case_group_id:
        dialog_case_group_ids && dialog_case_group_ids?.length
          ? dialog_case_group_ids[dialog_case_group_ids?.length - 1]
          : undefined,
      ...rest,
    },
  }
}

export const getGroupOptions = (groupList) => {
  return groupList.map((item) => {
    return {
      value: item.id,
      label: item.name,
      ...item,
      [item.sub_groups && item.sub_groups.length ? 'children' : '']:
        item.sub_groups && item.sub_groups.length ? getGroupOptions(item.sub_groups) : [],
    }
  })
}

export const formatValues = (treeData: any, level = 1) => {
  if (!treeData || treeData.length === 0) {
    return []
  }
  const res = []
  treeData?.map((item) => {
    const obj = { label: item?.name, value: item?.id, parentId: item?.parent_id, children: [] }

    let children = formatValues(item?.sub_groups, level + 1)

    // 反转顺序
    if (level === 1) {
      // 未分组的顺序不变
      const [unBind, ...rest] = children
      children = [...(unBind ? [unBind] : []), ...(rest?.reverse() || [])]
    } else {
      children.reverse()
    }

    obj.children = children
    res.push(obj)
  })
  return res
}

export const handleServing = (data: any, key?: string) => {
  if (key) {
    return data.map((item, index) => {
      return {
        title: item.content.cnick,
        key: `${item.id}_${index}`,
        ...item,
      }
    })
  } else {
    return data.map((item, index) => {
      return {
        title: item.cnick,
        key: `${item.id}_${index}`,
        ...item,
      }
    })
  }
}

// 展示订单状态
export const showStatus = (status: number) => {
  switch (status) {
    case 1:
      return '已下单'
    case 2:
      return '已下单'
    case 3:
      return '已下单'
    case 4:
      return '已下单'
    case 5:
      return '已下单'
    case 6:
      return '已下单'
    default:
      return '未下单'
  }
}

export const formateFetch = (search: any) => {
  return {
    index: search?.index,
    answer: search?.answer || undefined,
    task_id: search?.task_id,
  }
}
//textarea 实现可换行功能--获取光标位置
export const getCursortPosition = (ctrl) => {
  //获取光标位置函数
  let CaretPos = 0 // IE Support
  if (document.selection) {
    ctrl.focus()
    const Sel = document.selection.createRange()
    Sel.moveStart('character', -ctrl.value.length)
    CaretPos = Sel.text.length
  }
  // Firefox support
  else if (ctrl.selectionStart || ctrl.selectionStart == '0') CaretPos = ctrl.selectionStart
  return CaretPos
}

export const setCaretPosition = (ctrl, pos) => {
  //设置光标位置函数
  if (ctrl.setSelectionRange) {
    ctrl.focus()
    ctrl.setSelectionRange(pos, pos)
  } else if (ctrl.createTextRange) {
    const range = ctrl.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }
}

export const getStoryOptions = (storyList, level = 1) => {
  return (
    storyList?.map((i) => {
      let children = [...(i.sub_groups ? getStoryOptions(i.sub_groups, level + 1) : [])]
      children.push(
        ...(i.stories
          ? i.stories.map((v) => ({
              value: v.id,
              label: v.name,
              isStory: true,
              storySource: v.story_source,
            }))
          : [])
      )

      // 反转顺序
      if (level === 1) {
        // 未分组的顺序不变
        const [unBind, ...rest] = children
        children = [...(unBind ? [unBind] : []), ...(rest?.reverse() || [])]
      } else {
        // children.reverse()
      }

      return {
        value: i.id,
        label: i.name,
        children,
      }
    }) || []
  )
}

type OptionType = {
  value: string
  label: string
  children?: OptionType[]
}

// 用于获取Cascader所需的value格式以及label
export const cascaderValueMap = (value?: OptionType[]) => {
  const valueMap = new Map<string, { value: string[]; label: string }>()
  const nameMap = new Map<string, string>()

  if (!value) {
    return { valueMap, nameMap }
  }
  ;(function setMap(options: OptionType[], parentId?: string) {
    options.forEach((v) => {
      valueMap.set(v.value, {
        value: [...((parentId && valueMap.get(parentId)?.value) || []), v.value],
        label: v.label,
      })

      nameMap.set(v.value, nameMap.get(parentId) ? `${nameMap.get(parentId)}/${v.label}` : v.label)

      if (!v.children?.length) return

      setMap(v.children, v.value)
    })
  })(value)

  return { valueMap, nameMap }
}
